const getStartingPrice = (banquet) => Math.min(
  banquet.vegPrice ?? Number.POSITIVE_INFINITY,
  banquet.nonVegPrice ?? Number.POSITIVE_INFINITY
);

const fallbackFeaturedScore = (banquet) => (banquet.featured ? 1 : 0);

export const sortBanquets = (banquets, sortBy) => {
  const items = [...banquets];

  items.sort((left, right) => {
    switch (sortBy) {
      case "nearest":
        return (left.distanceKm ?? Number.POSITIVE_INFINITY) - (right.distanceKm ?? Number.POSITIVE_INFINITY)
          || right.googleRating - left.googleRating
          || right.googleRatingsTotal - left.googleRatingsTotal;
      case "lowest-price":
        return getStartingPrice(left) - getStartingPrice(right)
          || (left.distanceKm ?? Number.POSITIVE_INFINITY) - (right.distanceKm ?? Number.POSITIVE_INFINITY)
          || right.googleRating - left.googleRating;
      case "highest-capacity":
        return right.guestMax - left.guestMax
          || getStartingPrice(left) - getStartingPrice(right);
      case "best-rated":
        return right.googleRating - left.googleRating
          || right.googleRatingsTotal - left.googleRatingsTotal
          || (left.distanceKm ?? Number.POSITIVE_INFINITY) - (right.distanceKm ?? Number.POSITIVE_INFINITY);
      case "most-reviewed":
        return right.googleRatingsTotal - left.googleRatingsTotal
          || right.googleRating - left.googleRating;
      case "featured":
      default:
        return fallbackFeaturedScore(right) - fallbackFeaturedScore(left)
          || right.googleRating - left.googleRating
          || right.googleRatingsTotal - left.googleRatingsTotal
          || getStartingPrice(left) - getStartingPrice(right);
    }
  });

  return items;
};
